import { ChainlitAPI } from "@chainlit/react-client";

// const CHAINLIT_SERVER = "http://localhost:8000/chainlit"; // Uncomment for local development

const CHAINLIT_SERVER = "https://ag.digitalya.co/chainlit";

export const apiClient = new ChainlitAPI(CHAINLIT_SERVER, "webapp");
